import { useEffect } from "react";
import { useApp, boot, set } from "./store.ts";
import { TopBar, Numi, Icon } from "./ui.tsx";
import { Auth } from "./screens/Auth.tsx";
import { Kids } from "./screens/Kids.tsx";
import { Home, Syllabus, TopicScreen, Vedic } from "./screens/Home.tsx";
import { Wrap } from "./screens/Wrap.tsx";
import { Learn, Practice } from "./screens/Learn.tsx";
import { Bubbles } from "./screens/Bubbles.tsx";
import { Done, Stickers } from "./screens/Done.tsx";
import { Grownups } from "./screens/Grownups.tsx";
import { AskNumi } from "./screens/AskNumi.tsx";
import { TrialOver } from "./screens/TrialOver.tsx";
import { Landing } from "./screens/Landing.tsx";
import { Legal, LegalLinks, legalPage } from "./screens/Legal.tsx";
import { Admin, isAdminPath } from "./screens/Admin.tsx";
import { Unsubscribe, isUnsubPath } from "./screens/Unsubscribe.tsx";
import { TrickPeek } from "./screens/TrickPeek.tsx";
import { Plans } from "./screens/Plans.tsx";
import { Break } from "./screens/Break.tsx";


export function App() {
  const s = useApp();
  useEffect(() => { boot(); }, []);
  if (isAdminPath()) return <Admin />;
  if (isUnsubPath()) return <Unsubscribe />;
  const openGrown = () => set({ grownOpen: true });
  let body;
  switch (s.screen) {
    case "loading": body = <main style={{ alignItems: "center", paddingTop: 80 }}><Numi size={120} mood="fly" /><p>Loading Numi...</p></main>; break;
    case "landing": body = <Landing />; break;
    case "auth": body = <Auth />; break;
    case "kids": body = <Kids />; break;
    case "home": body = <Home openGrown={openGrown} />; break;
    case "syllabus": body = <Syllabus />; break;
    case "topic": body = <TopicScreen />; break;
    case "learn": body = <Learn />; break;
    case "play": body = s.qs ? <Practice /> : null; break;
    case "bubbles": body = s.bub ? <Bubbles /> : null; break;
    case "done": body = s.result ? <Done /> : null; break;
    case "stickers": body = <Stickers />; break;
    case "vedic": body = <Vedic />; break;
    case "wrap": body = <Wrap />; break;
  }
  const legal = legalPage(); if (legal) body = <Legal page={legal} />;
  else if (s.billing?.status === "expired" && s.child && !["auth", "kids", "loading"].includes(s.screen)) body = <TrialOver openGrown={openGrown} />;
  if (s.trickPeek && s.parent) body = <TrickPeek />;
  return <>
    <TopBar onGrown={openGrown} />
    {body}
    <p className="foot">Numi by LoopSkills · © Thrivecraft Ventures LLP · <LegalLinks /></p>
    {s.billing?.status !== "expired" && !legal && s.child && <AskNumi />}
    {s.grownOpen && s.child && <Grownups />}
    {s.grownOpen && !s.child && s.parent && <div className="scrim" onClick={(e) => { if (e.target === e.currentTarget) set({ grownOpen: false }); }}><section className="gsheet" role="dialog" aria-modal="true" aria-label="Plans">
      <button className="round close" aria-label="Close" onClick={() => set({ grownOpen: false })}><Icon name="x" /></button><h2>Plans</h2><Plans /></section></div>}
    {s.breakOpen && s.child && !s.grownOpen && <Break />}
    {s.toast && <div className="toast" role="status">{s.toast}</div>}
  </>;
}
